export const DEVELOPER_URLS = [
  "/myaccount",
  "/mysettings",
  "/myprofile",
  "/myaddress",
  "/mynotes_address",
  "/myapikey",
];
